export const PROTOCOL_VERSION = 1 as const;

export const PROTOCOL_NAMESPACE = "fluz-secure-elements" as const;

export type ElementsMessageType =
  | "handshake"
  | "handshake-ack"
  | "mount"
  | "style"
  | "reveal"
  | "set-mask"
  | "field-change"
  | "submit"
  | "submit-result"
  | "error";

export interface ElementsMessage<
  TType extends ElementsMessageType = ElementsMessageType,
  TPayload = unknown,
> {
  namespace: typeof PROTOCOL_NAMESPACE;
  version: typeof PROTOCOL_VERSION;
  mountId: string;
  type: TType;
  payload: TPayload;
}

export function createEnvelope<TType extends ElementsMessageType, TPayload>(
  mountId: string,
  type: TType,
  payload: TPayload,
): ElementsMessage<TType, TPayload> {
  return {
    namespace: PROTOCOL_NAMESPACE,
    version: PROTOCOL_VERSION,
    mountId,
    type,
    payload,
  };
}

export function isElementsMessage(value: unknown): value is ElementsMessage {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const candidate = value as Record<string, unknown>;
  return (
    candidate.namespace === PROTOCOL_NAMESPACE &&
    candidate.version === PROTOCOL_VERSION &&
    typeof candidate.mountId === "string" &&
    typeof candidate.type === "string"
  );
}
